export enum GlobalContext {
    GABI = 1,
    HINSCOPE = 2,
}

declare global {
    // eslint-disable-next-line no-var
    var ANALYTICS_GLOBAL_CONTEXT: string;
}

/**
 * This class handles the context around a patient based on the patient type, pathology and the associated devices
 * (e.g. is it RT monitoring ? Does the device support events ?)
 */
class PatientContextService_ {
    getGlobalContext(): GlobalContext {
        if (globalThis.ANALYTICS_GLOBAL_CONTEXT === 'hinscope') {
            return GlobalContext.HINSCOPE;
        }
        else {
            return GlobalContext.GABI;
        }
    }
}

export const PatientContextService = new PatientContextService_();
